import { Injectable, makeStateKey } from '@angular/core';
import { InsertService } from '@uc/web/core';
import { ClearingCourseSearch } from '../models/clearing-course-search.models';
import { CourseSearch } from '../models/course-search.models';

export const TS_NOT_FOUND_ERROR = makeStateKey<string>('ts-not-found-error');

@Injectable({ providedIn: 'root' })
export class InsertRecommendedCoursesService {
	constructor(private _insertSrv: InsertService) {}

	insertRecommendedCourses(courses: CourseSearch | ClearingCourseSearch | null) {
		const coursesClone = structuredClone(courses);
		if (!coursesClone) return null;

		const recommendedCourses =
			'subject_keywords' in coursesClone
				? coursesClone.subject_keywords
				: coursesClone.recommended_courses;
		// only add recommended courses if there is more than 1 course
		if (coursesClone && coursesClone.data?.length > 1 && recommendedCourses?.length) {
			recommendedCourses?.forEach((course) => (course.type = 'recommended'));

			const keywords = recommendedCourses ?? [];
			const data = coursesClone.data ?? [];
			const insertBy = {
				key: 'type',
				value: 'recommended',
			};

			const coursesData = this._insertSrv.insert(data, 3, keywords, insertBy);

			return { ...courses, data: coursesData };
		}

		return courses;
	}
}
